module.exports = __webpack_public_path__ + "media/images/lb/944-89eb456e5cd12ea31ef165bbb21e9d73.svg";